// src/components/layouts/GuestLayout.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import LandingHeader from '../landing/LandingHeader';
import LandingFooter from '../landing/LandingFooter';

const GuestLayout = () => {
  return (
    <div className="min-h-screen bg-[#f6ecf6] flex flex-col">
      <LandingHeader />
      <main className="flex-1">
        <Outlet />
      </main>
      <LandingFooter />
       {/* Back to Top Button */}
      <button
        id="scroll-top"
        className="fixed bottom-6 right-6 bg-purple-600 text-white p-3 rounded-full shadow-lg hover:bg-purple-700 transition-colors"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      >
        <i className="fas fa-chevron-up"></i>
      </button>
    </div>
  );
};

export default GuestLayout;